// Prevent Trix from accepting files
document.addEventListener("trix-file-accept", (e)=>{
    e.preventDefault();
});
